module.exports = __webpack_public_path__ + "static/media/bdsunglasses_cms.507b9014.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images_hd/BlackDiamond/bdsunglasses_cms.jpg
// module id = 654
// module chunks = 0